<template>
  <div class="box wrapper-payroll-deductions">
    <div class="title-container is-flex">
      <h4 class="title is-centered is-4 has-text-primary title-payroll-deductions">
        Deducciones
      </h4>
      <div class="field is-centered">
        <BTooltip
          class="add-button"
          label="Agregar deducción"
          type="is-success"
        >
          <a
            class="button add-deduction is-success is-rounded"
            @click="$store.commit('payroll/addDeductionRow')"
          >
            <BIcon icon="plus" />
          </a>
        </BTooltip>
      </div>
    </div>
    <BTable
      :data="deductionsWithIndex"
      :columns="columns"
    >
      <template slot-scope="props">
        <BTableColumn
          class="limit-300"
          field="deductionType"
          internal
        >
          <BField>
            <BSelect
              name="deductionType"
              placeholder="Selecciona el tipo"
              :value="props.row.deductionType"
              class="is-fullwidth"
              :disabled="loading"
              :loading="loading"
              required
              @input="onInput(props.row.id, 'deductionType', $event)"
            >
              <option
                v-for="option in deductionTypeCatalog"
                :key="option.value"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </BSelect>
          </BField>
        </BTableColumn>
        <BTableColumn
          field="key"
          internal
        >
          <BField>
            <BInput
              name="key"
              placeholder="Ingresa una clave de deducción"
              :value="props.row.key"
              required
              @input="onInput(props.row.id, 'key', $event)"
            />
          </BField>
        </BTableColumn>
        <BTableColumn
          field="concept"
          internal
        >
          <BField>
            <BInput
              name="concept"
              placeholder="Ingresa el concepto de la deducción"
              :value="props.row.concept"
              required
              @input="onInput(props.row.id, 'concept', $event)"
            />
          </BField>
        </BTableColumn>
        <BTableColumn
          field="amount"
          internal
        >
          <BField>
            <BInput
              name="amount"
              placeholder="Ingresa el monto a deducir"
              type="number"
              min="0"
              step="0.01"
              :value="props.row.amount"
              required
              @input="onInput(props.row.id, 'amount', $event)"
            />
          </BField>
        </BTableColumn>
        <BTableColumn
          field="actions"
          internal
        >
          <span class="actions">
            <a
              class="button is-danger"
              @click="$store.commit('payroll/deleteDeduction', props.row.id)"
            >
              <BIcon
                icon="delete"
                aria-hidden="true"
              />
            </a>
          </span>
        </BTableColumn>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <BIcon
                icon="emoticon-sad"
                size="is-large"
              />
            </p>
            <p>No has agregado deducciones</p>
          </div>
        </section>
      </template>
    </BTable>
  </div>
</template>

<script>
import { deductionType as deductionTypeCatalog } from '@machete/common-catalogs';

const normalizeCatalog = ({ key, value }) => ({ value: key, label: value });

export default {
  name: 'PayrollDeductions',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deductionTypeCatalog: deductionTypeCatalog.map(normalizeCatalog),
      columns: [
        { field: 'deductionType', label: 'Tipo de deducción', centered: true },
        { field: 'key', label: 'Clave', centered: true },
        { field: 'concept', label: 'Concepto', centered: true },
        { field: 'amount', label: 'Monto', centered: true },
        { field: 'actions', label: '', centered: true },
      ],
    };
  },
  computed: {
    deductionsWithIndex() {
      return this.$store.state.payroll.deductions.map((deduction, index) => ({
        ...deduction,
        id: index,
      }));
    },
  },
  methods: {
    onInput(index, name, value) {
      this.$store.commit('payroll/changeDeduction', { index, name, value });
    },
  },
};
</script>

<style scoped>
.title.is-4 {
  margin-bottom: 0;
}

.header-label {
  padding-right: 0.25rem;
}

.add-button {
  margin-right: 1.5rem;
}

.button.add-deduction {
  padding-left: 0.75em!important;
  padding-right: 0.75em!important;
}

.button.add-deduction .icon {
  margin-left: calc(-0.375em - 1px)!important;
  margin-right: calc(-0.375em - 1px)!important;
  font-size: inherit!important;
}

.add-deduction-label {
  padding-left: .5rem;
}

.title-container {
  width: 100%;
  align-items: center;
  padding-bottom: .3rem;
  justify-content: space-between;
}

.limit-300 {
  width: 300px;
}
</style>
